import React from 'react';
import $ from 'jquery';
import { OTHER_USER } from '../../../../constants/Labels';

class UserSettings extends React.Component {
  constructor(props) {
    super(props);
    this.section = 'user';
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.invalidFileds = [];
  }

  componentDidMount() {
    this.toggleBlurListeners(true);
  }

  componentWillUnmount() {
    this.toggleBlurListeners(false);
  }

  componentDidUpdate() {
    this.toggleBlurListeners(false);
    this.toggleBlurListeners(true);
  }

  toggleBlurListeners = addListeners => {
    if (addListeners) {
      $('#' + this.section)
        .find('input[name="uid"]')
        .on(
          'blur',
          (event => {
            this.props.validate(event, 'string', false, this);
          }).bind(this)
        );
    } else {
      $('#' + this.section)
        .find('input[name="uid"]')
        .off('blur');
    }
  };

  render() {
    return (
      <div className="pluginSettingsSection" id={this.section}>
        <div className="placementDescription">
          <div className="pluginSectionsTitle">User Settings</div>
          <div
            className="settingsDescription description"
            dangerouslySetInnerHTML={{ __html: OTHER_USER }}
          ></div>
        </div>
        <div className="settingsInputs">
          <div className="inputsRow">
            <div className="bigInput">
              <label>UID</label>
              <input
                type="text"
                name="uid"
                key={this.props.user.uid}
                className="textFiled"
                defaultValue={this.props.user.uid}
              />
              <div className="validationError"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UserSettings;
